import config from "../../../shared/config/config";
import axiosAdmin from "../../../shared/utils/axiosAdmin";
import { AllowIpDto, ConfigDto, FwocDto } from "../../../types/adminConfig";

const GATEWAY_URL = config.servers.gateway.url;

interface AdminConfigApi {
  getConfig(): Promise<ConfigDto>;
  setConfig(config: ConfigDto): Promise<ConfigDto>;
  getFwocConfig(): Promise<FwocDto>;
  getIpConfig(): Promise<AllowIpDto[]>;
  setIpConfig(newIp: AllowIpDto[]): Promise<AllowIpDto[]>;
}

class AdminConfigServerApi implements AdminConfigApi {
  async getConfig(): Promise<ConfigDto> {
    const resp = await axiosAdmin
      .get<ConfigDto>(`${GATEWAY_URL}/wapi/admins/config`)
      .then((value) => value.data);
    return resp;
  }
  async setConfig(config: ConfigDto): Promise<ConfigDto> {
    const resp = await axiosAdmin.post<ConfigDto>(
      `${GATEWAY_URL}/wapi/admins/config`,
      config
    );
    return Promise.resolve(resp.data);
  }
  async getFwocConfig(): Promise<FwocDto> {
    const resp = await axiosAdmin
      .get<FwocDto>(`${GATEWAY_URL}/wapi/admins/config/fwoc`)
      .then((value) => value.data);
    return resp;
  }
  async getIpConfig(): Promise<AllowIpDto[]> {
    const resp = await axiosAdmin
      .get<AllowIpDto[]>(`${GATEWAY_URL}/wapi/admins/config/access/control`)
      .then((value) => value.data);

    return resp;
  }
  async setIpConfig(newIp: AllowIpDto[]): Promise<AllowIpDto[]> {
    const resp = await axiosAdmin.post<AllowIpDto[]>(
      `${GATEWAY_URL}/wapi/admins/config/access/control`,
      newIp
    );
    return Promise.resolve(resp.data);
  }
}
const adminConfigApi: AdminConfigApi = new AdminConfigServerApi();
export default adminConfigApi;
